require("core-js/modules/es.array.concat");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "vant/es/button/style", "vant/es/button", "vant/es/icon/style", "vant/es/icon", "@/utils/time"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("vant/es/button/style"), require("vant/es/button"), require("vant/es/icon/style"), require("vant/es/icon"), require("@/utils/time"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.style, global.button, global.style, global.icon, global.time);
    global.outBoundList = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _style, _button, _style2, _icon, _time) {
  "use strict";

  var _interopRequireDefault = require("/root/deploy/iot-product-tool/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _button = _interopRequireDefault(_button);
  _icon = _interopRequireDefault(_icon);
  var _default = {
    name: "OutBoundList",
    components: {
      Icon: _icon.default,
      Button: _button.default
    },
    filters: {
      formateTime: _time.formateTime
    },
    data: function data() {
      return {
        // 分页
        pageNo: 1,
        pageSize: 10,
        resultList: [],
        isShowAll: false
      };
    },
    created: function created() {
      this.getOutbound();
    },
    methods: {
      // 获取库房出库记录
      getOutbound: function getOutbound() {
        var vm = this;
        var uuid = vm.$route.query.uuid || vm.$localStorage.getItem('uuid');
        var fType = vm.$strTool.filterFactoryType(uuid);
        var factoryType = vm.getOutboundFactoryType(fType);
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.MP_WECHAT_BASE_URL, "erpFactory/getOutbound"),
          params: {
            password: vm.$config.base.wechatPassword,
            factoryType: factoryType,
            pageSize: vm.pageSize,
            pageNo: vm.pageNo
          }
        }).then(function (res) {
          var records = res.data.records;

          if (vm.pageNo === 1) {
            vm.resultList = [];
          }

          vm.resultList = vm.resultList.concat(records);

          if (records.length < vm.pageSize) {
            vm.isShowAll = true;
          } else {
            vm.isShowAll = false;
          }
        });
      },
      onclickSelectItem: function onclickSelectItem(item) {
        this.$router.push({
          name: "OutBoundInfo",
          params: {
            item: item
          }
        });
      },
      trackNumBtn: function trackNumBtn(id) {
        this.$emit('track-num', id);
      },
      // 获取库房出库对应类型
      getOutboundFactoryType: function getOutboundFactoryType(type) {
        var factory = {
          'ruiyin': 2,
          'wangbo': 3,
          'haopai': 6
        };
        return factory[type] || 0;
      },
      // 点击加载更多
      loadMore: function loadMore() {
        var vm = this;
        vm.pageNo++;
        vm.getOutbound();
      }
    }
  };
  _exports.default = _default;
});